import styled from 'styled-components'
import { StyledTable, StyledTableButton } from '../../../../common/styled'

export const StyledMaskButton = styled(StyledTableButton)`
  &[disabled] {
    opacity: 0;
  }
  svg {
    transform: scale(2);
    margin-right: 5px;
  }
`

export const StyledDistrictAdminTable = styled(StyledTable)`
  .ant-table-tbody > tr > td {
    text-align: start;
  }
  .ant-table-thead > tr > th.ant-table-selection-column {
    text-align: start;
  }
`
